export interface LangueSise {
    code: string;
    libelle: string;
}

export const LANGUES_SISE: LangueSise[] = [
    { code: '0035', libelle: 'AJIE' },
    { code: '0068', libelle: 'ALBANAIS' },
    { code: '0026', libelle: 'ALLEMAND' },
    { code: '0141', libelle: 'ALSACIEN' },
    { code: '0036', libelle: 'AMHARIQUE' },
    { code: '0027', libelle: 'ANGLAIS' },
    { code: '0028', libelle: 'ARABE' },
    { code: '0107', libelle: 'ARABE EGYPTIEN' },
    { code: '0037', libelle: 'ARABE LITTERAL' },
    { code: '0038', libelle: 'ARABE MAGHREBIN' },
    { code: '0108', libelle: 'ARABE MAROCAIN' },
    { code: '0070', libelle: 'ARABE ORIENTAL' },
    { code: '0109', libelle: 'ARABE SYRO-LIBANAIS-PALESTINIEN' },
    { code: '0110', libelle: 'ARAMEEN' },
    { code: '0039', libelle: 'ARMENIEN' },
    { code: '0127', libelle: 'AYMARA' },
    { code: '0139', libelle: 'AZERBAIDJANAIS' },
    { code: '0128', libelle: 'AZERI' },
    { code: '0040', libelle: 'BANTU' },
    { code: '0041', libelle: 'BASQUE' },
    { code: '0042', libelle: 'BENGALI' },
    { code: '0030', libelle: 'BERBERE' },
    { code: '0111', libelle: 'BIELORUSSE' },
    { code: '0071', libelle: 'BIRMAN' },
    { code: '0133', libelle: 'BOSNIAQUE-CROATE-SERBE-MONTENEGRIN' },
    { code: '0001', libelle: 'BOSNIAQUE-SERBO-CROATE' },
    { code: '0034', libelle: 'BRETON' },
    { code: '0072', libelle: 'BULGARE' },
    { code: '0073', libelle: 'CAMBODGIEN (KHMER)' },
    { code: '0112', libelle: 'CANTONAIS' },
    { code: '0031', libelle: 'CATALAN' },
    { code: '0043', libelle: 'CELTIQUE' },
    { code: '0032', libelle: 'CHINOIS' },
    { code: '0113', libelle: 'COMORIEN' },
    { code: '0013', libelle: 'COREEN' },
    { code: '0044', libelle: 'CORSE' },
    { code: '0045', libelle: 'CREOLE' },
    { code: '0136', libelle: 'CROATE' },
    { code: '0046', libelle: 'DANOIS' },
    { code: '0047', libelle: 'DREHU' },
    { code: '0126', libelle: 'EGYPTIEN HIEROGLYPHIQUE' },
    { code: '0014', libelle: 'ESPAGNOL' },
    { code: '0074', libelle: 'ESTONIEN' },
    { code: '0092', libelle: 'FILIPINO' },
    { code: '0048', libelle: 'FINNOIS' },
    { code: '0123', libelle: 'FRANCAIS' },
    { code: '0075', libelle: 'GEORGIEN' },
    { code: '0067', libelle: 'GREC ANCIEN' },
    { code: '0018', libelle: 'GREC MODERNE' },
    { code: '0076', libelle: 'GUARANI' },
    { code: '0077', libelle: 'HAOUSSA' },
    { code: '0065', libelle: 'HEBREU' },
    { code: '0016', libelle: 'HEBREU ANCIEN' },
    { code: '0017', libelle: 'HEBREU MODERNE' },
    { code: '0049', libelle: 'HINDI' },
    { code: '0142', libelle: 'HMONG' },
    { code: '0015', libelle: 'HONGROIS' },
    { code: '0050', libelle: 'INDONESIEN' },
    { code: '0078', libelle: 'INDONESIEN-MALAISIEN' },
    { code: '0079', libelle: 'INUKTITUT' },
    { code: '0132', libelle: 'IRLANDAIS' },
    { code: '0051', libelle: 'ISLANDAIS' },
    { code: '0019', libelle: 'ITALIEN' },
    { code: '0022', libelle: 'JAPONAIS' },
    { code: '0114', libelle: 'JUDEO-ARABE' },
    { code: '0115', libelle: 'JUDEO-ESPAGNOL' },
    { code: '0134', libelle: 'KHMER' },
    { code: '0080', libelle: 'KURDE' },
    { code: '0116', libelle: 'KURMANJI' },
    { code: '0135', libelle: 'LANGUE DES SIGNES' },
    { code: '0144', libelle: 'LANGUES AMERINDIENNES' },
    { code: '0122', libelle: 'LANGUES ANDINES' },
    { code: '0023', libelle: 'LANGUES INDIENNES' },
    { code: '0021', libelle: 'LANGUES IRANIENNES' },
    { code: '0052', libelle: 'LANGUES MELANESIENNES' },
    { code: '0081', libelle: 'LANGUES OCEANIENNES' },
    { code: '0024', libelle: 'LANGUES POLYNESIENNES' },
    { code: '0138', libelle: 'LANGUES ROMANES' },
    { code: '0005', libelle: 'LANGUES SCANDINAVES' },
    { code: '0117', libelle: 'LANGUES SEPHARADES' },
    { code: '0025', libelle: "LANGUES SLAVES D'EUROPE CENTRALE" },
    { code: '0082', libelle: 'LAOTIEN' },
    { code: '0066', libelle: 'LATIN' },
    { code: '0083', libelle: 'LETTON' },
    { code: '0118', libelle: 'LINGALA' },
    { code: '0084', libelle: 'LITUANIEN' },
    { code: '0085', libelle: 'MACEDONIEN' },
    { code: '0033', libelle: 'MALGACHE' },
    { code: '0125', libelle: 'MANDARIN' },
    { code: '0054', libelle: 'MANDINGUE' },
    { code: '0086', libelle: 'MAYA' },
    { code: '0087', libelle: 'MONGOL' },
    { code: '0088', libelle: 'NAHUATL' },
    { code: '0011', libelle: 'NEERLANDAIS' },
    { code: '0143', libelle: 'NENGE TONGO' },
    { code: '0089', libelle: 'NEPALI' },
    { code: '0055', libelle: 'NORVEGIEN' },
    { code: '0012', libelle: 'OCCITAN' },
    { code: '0129', libelle: 'OSSETE' },
    { code: '0090', libelle: 'OURDOU' },
    { code: '0091', libelle: 'PASHTO' },
    { code: '0064', libelle: 'PERSAN' },
    { code: '0056', libelle: 'PEUL' },
    { code: '0124', libelle: 'PICARD' },
    { code: '0131', libelle: 'POITEVIN SAINTONGEAIS' },
    { code: '0006', libelle: 'POLONAIS' },
    { code: '0007', libelle: 'PORTUGAIS' },
    { code: '0105', libelle: 'QAZAQ' },
    { code: '0093', libelle: 'QUECHUA' },
    { code: '0009', libelle: 'ROUMAIN' },
    { code: '0094', libelle: 'RROMANI' },
    { code: '0010', libelle: 'RUSSE' },
    { code: '0063', libelle: 'SANSKRIT' },
    { code: '0137', libelle: 'SERBE' },
    { code: '0059', libelle: 'SIAMOIS' },
    { code: '0095', libelle: 'SINGHALAIS' },
    { code: '0096', libelle: 'SLOVAQUE' },
    { code: '0097', libelle: 'SLOVENE' },
    { code: '0119', libelle: 'SORABE' },
    { code: '0120', libelle: 'SORANI' },
    { code: '0060', libelle: 'SUEDOIS' },
    { code: '0106', libelle: 'SWAHILI' },
    { code: '0061', libelle: 'TAHITIEN' },
    { code: '0098', libelle: 'TAMOUL' },
    { code: '0121', libelle: 'TATAR' },
    { code: '0002', libelle: 'TCHEQUE' },
    { code: '0099', libelle: 'TELOUGOU' },
    { code: '0140', libelle: 'THAI' },
    { code: '0100', libelle: 'TIBETAIN' },
    { code: '0101', libelle: 'TSIGANE' },
    { code: '0003', libelle: 'TURC' },
    { code: '0102', libelle: 'UKRAINIEN' },
    { code: '0004', libelle: 'VIETNAMIEN' },
    { code: '0103', libelle: 'WOLOF' },
    { code: '0104', libelle: 'YIDDISH' },
    { code: '0062', libelle: 'YORUBA' },
    { code: '0130', libelle: 'ZOULOU' }
];
